// import React from 'react'
// import {
//   CRow,
//   CCol,
//   CWidgetStatsA,
// } from '@coreui/react'
// import { getStyle } from '@coreui/utils'
// import { CChartBar, CChartLine } from '@coreui/react-chartjs'
// import PropTypes from "prop-types";
// import { CChartDoughnut } from '@coreui/react-chartjs';


// const WidgetsDropdown = (props) => {
//   const { usersCount = 0, incomeCount = 0, aaddharUsageCount = 0, aaddharTokenBalance = 0, } = props;
//   return (
//     <CRow>
//       <CCol sm={6} lg={3}>
//         <CWidgetStatsA
//           className="mb-4"
//           color="primary"
//           value={<>{usersCount}</>}
//           title="Users"
//           chart={
//             <CChartDoughnut
//               className="mt-3 mx-auto"
//               style={{ height: '90px', width: '90px' }}
//               data={{
//                 labels: ['Active', 'Inactive'],
//                 datasets: [
//                   {
//                     data: [usersCount, 100 - usersCount],
//                     backgroundColor: [
//                       getStyle('--cui-primary'),
//                       'rgba(255, 255, 255, 0.2)',
//                     ],
//                     borderColor: [
//                       'rgba(255, 255, 255, 0.2)',
//                       'rgba(255, 255, 255, 0.2)',
//                     ],
//                     hoverOffset: 4,
//                   },
//                 ],
//               }}
//               options={{
//                 plugins: {
//                   legend: {
//                     display: false,
//                   },
//                   tooltip: {
//                     enabled: true,
//                   },
//                 },
//                 cutout: '70%',
//                 maintainAspectRatio: false,
//               }}
//             />
//           }
//         />
//       </CCol>

//       <CCol sm={6} lg={3}>
//         <CWidgetStatsA
//           className="mb-4"
//           color="info"
//           value={
//             <>
//               {parseInt(incomeCount || 0, 10).toLocaleString('en-IN')}
//             </>
//           }
//           title="Disbursement Amount"
//           chart={
//             <CChartLine
//               className="mt-3 mx-3"
//               style={{ height: '70px' }}
//               data={{
//                 labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
//                 datasets: [
//                   {
//                     label: 'My First dataset',
//                     backgroundColor: 'transparent',
//                     borderColor: 'rgba(255,255,255,.55)',
//                     pointBackgroundColor: getStyle('--cui-info'),
//                     data: [1, 18, 9, 17, 34, 22, 11],
//                   },
//                 ],
//               }}
//               options={{
//                 plugins: {
//                   legend: {
//                     display: false,
//                   },
//                 },
//                 maintainAspectRatio: false,
//                 scales: {
//                   x: {
//                     grid: {
//                       display: false,
//                       drawBorder: false,
//                     },
//                     ticks: {
//                       display: false,
//                     },
//                   },
//                   y: {
//                     min: -9,
//                     max: 39,
//                     display: false,
//                     grid: {
//                       display: false,
//                     },
//                     ticks: {
//                       display: false,
//                     },
//                   },
//                 },
//                 elements: {
//                   line: {
//                     borderWidth: 1,
//                   },
//                   point: {
//                     radius: 4,
//                     hitRadius: 10,
//                     hoverRadius: 4,
//                   },
//                 },
//               }}
//             />
//           }
//         />
//       </CCol>
//       <CCol sm={6} lg={3}>
//         <CWidgetStatsA
//           className="mb-4"
//           color="warning"
//           value={
//             <>
//               {aaddharUsageCount}
//             </>
//           }
//           title="Aaddhar Token Usage"
//           // action={
//           //   <CDropdown alignment="end">
//           //     <CDropdownToggle color="transparent" caret={false} className="p-0">
//           //       <CIcon icon={cilOptions} className="text-high-emphasis-inverse" />
//           //     </CDropdownToggle>
//           //     <CDropdownMenu>
//           //       <CDropdownItem>Action</CDropdownItem>
//           //       <CDropdownItem>Another action</CDropdownItem>
//           //       <CDropdownItem>Something else here...</CDropdownItem>
//           //       <CDropdownItem disabled>Disabled action</CDropdownItem>
//           //     </CDropdownMenu>
//           //   </CDropdown>
//           // }
//           chart={
//             <CChartLine
//               className="mt-3"
//               style={{ height: '70px' }}
//               data={{
//                 labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
//                 datasets: [
//                   {
//                     label: 'My First dataset',
//                     backgroundColor: 'rgba(255,255,255,.2)',
//                     borderColor: 'rgba(255,255,255,.55)',
//                     data: [78, 81, 80, 45, 34, 12, 40],
//                     fill: true,
//                   },
//                 ],
//               }}
//               options={{
//                 plugins: {
//                   legend: {
//                     display: false,
//                   },
//                 },
//                 maintainAspectRatio: false,
//                 scales: {
//                   x: {
//                     display: false,
//                   },
//                   y: {
//                     display: false,
//                   },
//                 },
//                 elements: {
//                   line: {
//                     borderWidth: 2,
//                     tension: 0.4,
//                   },
//                   point: {
//                     radius: 0,
//                     hitRadius: 10,
//                     hoverRadius: 4,
//                   },
//                 },
//               }}
//             />
//           }
//         />
//       </CCol>
//       <CCol sm={6} lg={3}>
//         <CWidgetStatsA
//           className="mb-4"
//           color="danger"
//           value={
//             <>
//               {aaddharTokenBalance}
//             </>
//           }
//           title="Aadhar Token Balance"
//           // action={
//           //   <CDropdown alignment="end">
//           //     <CDropdownToggle color="transparent" caret={false} className="p-0">
//           //       <CIcon icon={cilOptions} className="text-high-emphasis-inverse" />
//           //     </CDropdownToggle>
//           //     <CDropdownMenu>
//           //       <CDropdownItem>Action</CDropdownItem>
//           //       <CDropdownItem>Another action</CDropdownItem>
//           //       <CDropdownItem>Something else here...</CDropdownItem>
//           //       <CDropdownItem disabled>Disabled action</CDropdownItem>
//           //     </CDropdownMenu>
//           //   </CDropdown>
//           // }
//           chart={
//             <CChartBar
//               className="mt-3 mx-3"
//               style={{ height: '70px' }}
//               data={{
//                 labels: [
//                   'January',
//                   'February',
//                   'March',
//                   'April',
//                   'May',
//                   'June',
//                   'July',
//                   'August',
//                   'September',
//                   'October',
//                   'November',
//                   'December',
//                   'January',
//                   'February',
//                   'March',
//                   'April',
//                 ],
//                 datasets: [
//                   {
//                     label: 'My First dataset',
//                     backgroundColor: 'rgba(255,255,255,.2)',
//                     borderColor: 'rgba(255,255,255,.55)',
//                     data: [78, 81, 80, 45, 34, 12, 40, 85, 65, 23, 12, 98, 34, 84, 67, 82],
//                     barPercentage: 0.6,
//                   },
//                 ],
//               }}
//               options={{
//                 maintainAspectRatio: false,
//                 plugins: {
//                   legend: {
//                     display: false,
//                   },
//                 },
//                 scales: {
//                   x: {
//                     grid: {
//                       display: false,
//                       drawTicks: false,
//                     },
//                     ticks: {
//                       display: false,
//                     },
//                   },
//                   y: {
//                     grid: {
//                       display: false,
//                       drawBorder: false,
//                       drawTicks: false,
//                     },
//                     ticks: {
//                       display: false,
//                     },
//                   },
//                 },
//               }}
//             />
//           }
//         />
//       </CCol>
//     </CRow>
//   )
// }

// WidgetsDropdown.propTypes = {
//   usersCount: PropTypes.number,
//   incomeCount: PropTypes.number,
//   aaddharUsageCount: PropTypes.number,
//   aaddharTokenBalance: PropTypes.number
// };
import React from 'react';
import PropTypes from 'prop-types';
import { CCard, CCardBody } from '@coreui/react';
import { Doughnut, Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Filler
} from 'chart.js';

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Filler
);

const WidgetsDropdown = ({
  smsBalance = 0,
  aadharBalance = 0,
  totalEmployees = 0,
  totalRetailers = 0,
  yearlyCustomers = 7,
  monthlyCustomers = 3,
  weeklyCustomers = 2,
  dailyCustomers = 1,
  todayPayments = 0,
  monthlyPayments = 0,
  yearlyPayments = 0,
}) => {
  const totalCustomers = yearlyCustomers + monthlyCustomers + weeklyCustomers + dailyCustomers;

  const doughnutData = {
    labels: ['Yearly', 'Monthly', 'Weekly', 'Daily'],
    datasets: [{
      label: 'Customers',
      data: [yearlyCustomers, monthlyCustomers, weeklyCustomers, dailyCustomers],
      backgroundColor: ['#ff7f0e', '#d62728', '#2ca02c', '#ffdf00'],
      borderColor: ['#ffffff'],
      borderWidth: 2,
    }],
  };

  return (
    <div className="widgets-container">

      {/* Row 1 */}
      <div className="widgets-row">
        {/* Profile Overview */}
        <div style={{ flex: 1, minWidth: '300px' }}>
          <CCard className="widgets-card" style={{ backgroundColor: '#1f2937', color: '#fff', height: '300px' }}>
            <CCardBody>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
                <div style={{
                  backgroundColor: '#fff',
                  color: '#1f2937',
                  borderRadius: '50%',
                  width: '40px',
                  height: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 'bold',
                  fontSize: '18px',
                  marginRight: '12px',
                }}>V</div>
                <div>
                  <div style={{ fontWeight: 'bold', fontSize: '18px' }}>Pardeep Malik</div>
                  <div style={{ fontSize: '14px', color: '#d1d5db' }}>Riyms Micro Foundation </div>
                </div>
              </div>
              <div style={{ fontSize: '14px', marginBottom: '6px' }}>
                <strong>Phone Number:</strong><br />+91 9255935551
              </div>
              <div style={{ fontSize: '14px', marginBottom: '6px' }}>
                {/* <strong>Email Address:</strong><br />rambir5910@gmail.com */}
              </div>
              <div style={{ fontSize: '14px' }}>
                {/* <strong>Joined on:</strong><br />2025-03-11 */}
              </div>
            </CCardBody>
          </CCard>
        </div>

        {/* Customer Overview */}
        <div style={{ flex: 1, minWidth: '300px' }}>
          <CCard className="widgets-card" style={{ height: '300px' }}>
            <CCardBody>
              <div className="widgets-title">Customer Overview</div>

              {/* Flex container for customer info and doughnut chart */}
              <div className="customer-overview-container">

                {/* Left section for customer info */}
                <div className="customer-list-section">
                  <ul className="customer-list">
                    <li><span style={{ color: '#0b486b' }}>●</span> Total Customers: {totalCustomers}</li>
                    <li><span style={{ color: '#ff7f0e' }}>●</span> Yearly: {yearlyCustomers}</li>
                    <li><span style={{ color: '#d62728' }}>●</span> Monthly: {monthlyCustomers}</li>
                    <li><span style={{ color: '#2ca02c' }}>●</span> Weekly: {weeklyCustomers}</li>
                    <li><span style={{ color: '#ffdf00' }}>●</span> Daily: {dailyCustomers}</li>
                  </ul>
                </div>

                {/* Right section for Doughnut chart */}
                <div className="doughnut-container">
                  <Doughnut data={doughnutData} options={{
                    cutoutPercentage: 70,
                    rotation: Math.PI,
                    plugins: {
                      legend: {
                        position: 'bottom',
                        labels: { font: { size: 12 }, color: '#333' }
                      }
                    },
                    elements: {
                      arc: {
                        borderWidth: 5,
                        borderColor: '#fff',
                      }
                    }
                  }} />
                </div>

              </div>
            </CCardBody>
          </CCard>
        </div>



        {/* Financer Overview */}
        <div style={{ flex: 1, minWidth: '300px' }}>
          <CCard className="widgets-card" style={{ height: '300px' }}>
            <CCardBody>
              <div className="widgets-title">Financer Overview</div>
              <div className="widgets-item"><div>SMS Balance</div><div className="widgets-value">{smsBalance}</div></div>
              <div className="widgets-item"><div>Aadhar Balance</div><div className="widgets-value">{aadharBalance}</div></div>
              <div className="widgets-item"><div>Total Employees</div><div className="widgets-value">{totalEmployees}</div></div>
              <div className="widgets-item"><div>Total Retailers</div><div className="widgets-value">{totalRetailers}</div></div>
            </CCardBody>
          </CCard>
        </div>
      </div>

      {/* Row 2: Projects and Loans */}
      <div className="widgets-row">
        {/* Projects */}
        <div style={{ flex: 1, minWidth: '300px' }}>
          <CCard className="widgets-card" style={{ height: '300px' }}>
            <CCardBody>
              <div className="widgets-title">Projects</div>
              <div className="projects-container">
                <div className="widgets-box">
                  <div className="widgets-title">Account Management</div>
                  <div className="widgets-item"><div>Monthly</div><div className="widgets-value">0</div></div>
                  <div className="widgets-item"><div>Yearly</div><div className="widgets-value">0</div></div>
                  <div className="widgets-item"><div>Daily</div><div className="widgets-value">0</div></div>
                  <div className="widgets-footer"><div>Total: 6 / 10</div></div>
                </div>
                <div className="widgets-box">
                  <div className="widgets-title">EMIs</div>
                  <div className="widgets-item"><div>Yearly</div><div className="widgets-value">5</div></div>
                  <div className="widgets-item"><div>Monthly</div><div className="widgets-value">2</div></div>
                  <div className="widgets-item"><div>Today</div><div className="widgets-value">0</div></div>
                </div>
              </div>
            </CCardBody>
          </CCard>
        </div>

        {/* Loans */}
        <div style={{ flex: 1, minWidth: '300px' }}>
          <CCard className="widgets-card" style={{ height: '300px' }}>
            <CCardBody>
              <div className="widgets-title">Loans</div>
              <div className="widgets-item"><div>Approved</div><div className="widgets-value">0</div></div>
              <div className="widgets-item"><div>Disbursed</div><div className="widgets-value">4</div></div>
              <div className="widgets-item"><div>Pending</div><div className="widgets-value">2</div></div>
            </CCardBody>
          </CCard>
        </div>
      </div>

      {/* Row 3: Performance (2/3) & Payments (1/3) */}
      <div className="widgets-row">
        {/* Performance */}
        <div style={{ flex: 2, minWidth: '300px' }}>
          <CCard className="widgets-card" style={{ height: '370px' }}>
            <CCardBody>
              <div className="widgets-title">Performance</div>
              <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#198754' }}>
                98% <span style={{ fontSize: '14px', color: '#20c997' }}>↑ 12% vs last year</span>
              </div>
              <div style={{ height: '200px', marginTop: '20px' }}>
                <Line data={{
                  labels: ['Yearly', 'Monthly', 'Today'],
                  datasets: [{
                    label: 'EMI Collection',
                    data: [5000, 1800, 200],
                    fill: true,
                    backgroundColor: 'rgba(0, 201, 167, 0.2)',
                    borderColor: 'rgba(0, 201, 167, 1)',
                    tension: 0.4,
                  }]
                }} options={{
                  plugins: { legend: { display: false } },
                  scales: {
                    x: { ticks: { color: '#6c757d' }, grid: { display: false } },
                    y: { beginAtZero: true, ticks: { color: '#6c757d' }, grid: { color: '#e3e6f0' } }
                  }
                }} />
              </div>
            </CCardBody>
          </CCard>
        </div>

        {/* Payments */}
        <div style={{ flex: 1, minWidth: '300px' }}>
          <CCard className="widgets-card" style={{ height: '370px' }}>
            <CCardBody>
              <div className="widgets-title">Payments</div>
              <div className="widgets-item"><div>Today</div><div className="widgets-value">{todayPayments}</div></div>
              <div className="widgets-item"><div>Monthly</div><div className="widgets-value">{monthlyPayments}</div></div>
              <div className="widgets-item"><div>Yearly</div><div className="widgets-value">{yearlyPayments}</div></div>
            </CCardBody>
          </CCard>
        </div>
      </div>

    </div>
  );
};

WidgetsDropdown.propTypes = {
  smsBalance: PropTypes.number,
  aadharBalance: PropTypes.number,
  totalEmployees: PropTypes.number,
  totalRetailers: PropTypes.number,
  yearlyCustomers: PropTypes.number,
  monthlyCustomers: PropTypes.number,
  weeklyCustomers: PropTypes.number,
  dailyCustomers: PropTypes.number,
  todayPayments: PropTypes.number,
  monthlyPayments: PropTypes.number,
  yearlyPayments: PropTypes.number,
};

export default WidgetsDropdown;
